<div class="dialog-header">
    <h2 mat-dialog-title>Change Password</h2>
    <button mat-icon-button class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="mat-dialog-content">
    <form [formGroup]="form" class="user-form" (ngSubmit)="submit()">
        <div class="form-field-container">
            <mat-form-field appearance="outline">
                <mat-label>Old Password</mat-label>
                <input matInput [type]="showOldPassword() ? 'text' : 'password'" formControlName="oldPassword" />
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="toggleOldPassword()"
                    [attr.aria-label]="showOldPassword() ? 'Hide password' : 'Show password'"
                >
                    <mat-icon>{{ showOldPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>
            @if (form.get('oldPassword')?.hasError('required') && form.get('oldPassword')?.touched) {
                <div class="error-wrapper">
                    Old Password is required
                </div>
            }
        </div>

        <div class="form-field-container">
            <mat-form-field appearance="outline">
                <mat-label>New Password</mat-label>
                <input matInput [type]="showPassword() ? 'text' : 'password'" formControlName="newPassword" />
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePassword()"
                    [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                >
                    <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>
            @if (form.get('newPassword')?.hasError('required') && form.get('newPassword')?.touched) {
                <div class="error-wrapper">
                    New Password is required
                </div>
            }
            @if (form.hasError('sameAsOld') && form.get('confirmPassword')?.touched) {
                <div class="error-wrapper">
                    New password cannot be the same as the current password
                </div>
            }
        </div>

        <div class="form-field-container">
            <mat-form-field appearance="outline">
                <mat-label>Confirm Password</mat-label>
                <input matInput [type]="showConfirmPassword() ? 'text' : 'password'" formControlName="confirmPassword" />
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="toggleConfirmPassword()"
                    [attr.aria-label]="showConfirmPassword() ? 'Hide confirm password' : 'Show confirm password'"
                >
                    <mat-icon>{{ showConfirmPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>
            @if (form.get('confirmPassword')?.hasError('required') && form.get('confirmPassword')?.touched) {
                <div class="error-wrapper">
                    Confirm Password is required
                </div>
            }
            @if (!form.get('confirmPassword')?.hasError('required') && form.hasError('mismatch') && form.get('confirmPassword')?.touched) {
                <div class="error-wrapper">
                    Passwords do not match
                </div>
            }
        </div>
        <app-password-strength [password]="form.get('newPassword')?.value"></app-password-strength>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="action-btns">
    <button mat-stroked-button color="warn" class="btn-color-dark" (click)="closeDialog()">Cancel</button>
    <button mat-flat-button (click)="submit()" class="add-btn"
        [disabled]="loading() || form.invalid">
        @if (loading()) {
            <mat-progress-spinner diameter="20" mode="indeterminate" color="accent" class="button-spinner">
            </mat-progress-spinner>
        } @else {
            Update Password
        }
    </button>
</mat-dialog-actions>